import { t } from '../../../../lang';
import { createRootModal } from '../../RootModal';
import './SelectNetwork.scss';
import SelectNetworkBody from './SelectNetworkBody';

const SelectNetwork = createRootModal(SelectNetworkBody, {
	config: {
		title: t('Select network'),
		isOpen: true,
		height: '70%',
	},
});

export default SelectNetwork;
